import React, { useEffect, useState } from 'react';
import { Redirect, Link } from 'react-router-dom';
// import LayoutWrapperTopbar from '../../components/LayoutWrapperTopbar/LayoutWrapperTopbar'
// import LayoutWrapperMain from '../../components/LayoutWrapperMain/LayoutWrapperMain'
// import LayoutWrapperFooter from '../../components/LayoutWrapperFooter/LayoutWrapperFooter'
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer.js';

// import LayoutWrapperFooter from '../../components/LayoutWrapperFooter/LayoutWrapperFooter'
import {
  // Page,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  // Footer,
  // IconSpinner,
} from '../../components/LayoutComposer';
import { Page } from '../../components';
import IconSpinner from '../IconSpinner/IconSpinner';
// import { TwitterTweetEmbed } from 'react-twitter-embed';

// import { TopbarContainerComponent } from '../TopbarContainer/TopbarContainer';
// import { NotFoundPage, TopbarContainer } from '../../containers/';
import NotFoundPage from '../NotFoundPage/NotFoundPage.js';
import css from './BlogPage.module.css';
import moment from 'moment';
import { connect } from 'react-redux';
import { createSlug } from '../../util/urlHelpers';
import renderHTML from 'react-render-html';
import { stripHtml } from 'string-strip-html';
import { getSeoStuffMaybe } from '../../util/blogHelpers';

import defaultImage from '../../assets/default.png';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { compose } from 'redux';

const STRAPI_URL = process.env.REACT_APP_STRAPI_BACKEND_URL;

const BlogPost = props => {
  const {
    title,
    body = '',
    image,
    createdAt: created_at,
    updatedAt: updated_at,
    categories,
    fetchInProgress,
    fetchInProgressError,
    seo,
    scrollingDisabled,
  } = props;

  if (fetchInProgress) {
    return <LoadingPage />;
  }

  if (fetchInProgressError) {
    return <NotFoundPage />;
  }
  // let newbody=   '<blockquote class="twitter-tweet"><p lang="en" dir="ltr">At dawn from the gateway to Mars, the launch of Starship’s second flight test <a href="https://t.co/ffKnsVKwG4">pic.twitter.com/ffKnsVKwG4</a></p>&mdash; SpaceX (@SpaceX) <a href="https://twitter.com/SpaceX/status/1732824684683784516?ref_src=twsrc%5Etfw">December 7, 2023</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'+ "<p><strong>Here are some key points related to homeschooling in Alabama as of 2021:</strong></p><p><br></p><ol><li><strong>Declaration of Intent:</strong> Parents or guardians who wish to homeschool their children in Alabama must file a \"Declaration of Intent\" with the local superintendent's office or the Alabama State Department of Education. This declaration typically includes basic information about the homeschooling program, such as the names and ages of the children being homeschooled, the address of the homeschool, and the credentials of the parent or guardian providing instruction.</li><li><strong>Teacher Qualifications:</strong> Alabama requires that the parent or guardian providing instruction in a homeschool setting has a high school diploma or GED. There are no specific teacher certification requirements.</li><li><strong>Subjects to Be Taught:</strong> Homeschooling parents in Alabama are required to teach subjects typically taught in public schools, including reading, writing, math, science, and social studies.</li><li><strong>Assessment:</strong> Alabama law requires that homeschooled students be assessed annually. The purpose of the assessment is to ensure that students are making satisfactory progress in their homeschool program. Acceptable forms of assessment include standardized tests, an evaluation by a certified teacher, or a portfolio review.</li><li><strong>Attendance:</strong> Homeschooled students in Alabama must attend a minimum of 140 days of instruction per school year, and each day of instruction must consist of at least three hours.</li><li><strong>Notification:</strong> If you decide to homeschool, you must notify your local school district by submitting a Declaration of Intent. This notification should be submitted on or before the start of the public school year.</li><li><strong>Access to Extracurricular Activities:</strong> Alabama law allows homeschool students to participate in extracurricular activities and classes at public schools in their district. However, specific eligibility requirements may vary by district, so it's essential to check with your local school district for their policies.</li><li><strong>Graduation:</strong> Homeschooled students in Alabama do not receive a state-issued diploma. Instead, they can receive a parent-issued diploma, and it's up to the parent or guardian to determine the requirements for graduation.</li></ol><p><br></p><p>Please be aware that homeschooling laws and regulations can change over time, so it's crucial to verify this information with the Alabama Department of Education or a local homeschooling association for the most current requirements and guidance if you are considering homeschooling your child in Alabama. Additionally, consulting with a legal professional knowledgeable about homeschooling in Alabama can provide further clarity on compliance with state laws.</p>"

  // console.log("type",typeof(body))
  // console.log("props",newbody)
  const description = stripHtml(body).result;
  const schemaImages = '';
  const imageURL = image?.formats?.medium?.url ?? defaultImage;
  const content = body?.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
  console.log("content",typeof(content))
  return (
    <Page
      title={seo?.meta_title ? seo?.meta_title : title || 'Blog post'}
      scrollingDisabled={scrollingDisabled}
      author="Groundz"
      contentType="website"
      description={seo?.meta_description ? seo?.meta_description : description}
      {...getSeoStuffMaybe(seo)}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'ItemPage',
        description: seo?.meta_description ? seo?.meta_description : description,
        name: seo?.meta_title ? seo?.meta_title : seo?.meta_description,
        image: schemaImages,
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.root}>
            <div className={css.column2}>
              <>
                <div className={css.imageWrapper}>
                  <div className={css.gradient} />
                  {/* <h1 className={css.title}>{title}</h1> */}
                  <img src={imageURL} alt={title} className={css.featureimage} />
                </div>
                <div className={css.dates}>
                  <p className={css.datetime}>
                    Published:{' '}
                    {moment(created_at)
                      .format('DD MMM YYYY')
                      .toUpperCase()}
                  </p>
                  <p className={css.datetime}>
                    Updated:{' '}
                    {moment(updated_at)
                      .format('DD MMM YYYY')
                      .toUpperCase()}
                  </p>
                </div>
                {categories.length > 0 && (
                  <p className={css.tags}>
                    Categories:
                    {categories.map(c => (
                      <span key={c.Category}>
                        <Link to={`/c/${createSlug(c.Category)}/${c.id}`}>{c.Category}</Link>
                      </span>
                    ))}
                  </p>
                )}
                <div
                  className={css.content}
                  // dangerouslySetInnerHTML={{
                  //   __html: post.contentdata,
                  // }}
                >
                  <h2>{title}</h2>
                  {renderHTML(content ?? '')}
                  {/* <TwitterTweetEmbed /> */}
                </div>
              </>
            </div>
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <FooterContainer />

          {/* <Footer /> */}
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  const { BlogPage } = state;
  return {
    ...BlogPage,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BlogPost);

const LoadingPageComponent = props => {
  const { scrollingDisabled } = props;
  return (
    <Page
      title="Loading ..."
      scrollingDisabled={scrollingDisabled}
      // author={authorDisplayName}
      contentType="website"
      description="Loading ..."
      // facebookImages={facebookImages}
      // twitterImages={twitterImages}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'ItemPage',
        description: 'Loading...',
        name: 'Loading ...',
        image: 'Loading ...',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.loadingContainer}>
            <IconSpinner className={css.loading} />
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>{/* <Footer /> */}</LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToPropsLoading = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};
const mapDispatchToPropsLoading = dispatch => ({});

export const LoadingPage = compose(
  connect(
    mapStateToPropsLoading,
    mapDispatchToPropsLoading
  )
)(LoadingPageComponent);
